class MenuTabsTbl extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-tab]'));
    this.container = this.closest('.menu-drawer__navigation-container');
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.select(button));
    });
  }

  select(activeButton) {
    this.buttons.forEach((button) => {
      const isActive = button === activeButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    this.container.querySelectorAll('[data-tab-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.tabPanel !== activeButton.dataset.tab;
    });
  }
}

customElements.define('menu-tabs-tbl', MenuTabsTbl);
